import React, { useState } from 'react'
import NavBelt from '../page-essentials/NavBelt'
import TestReponsive from '../page-essentials/TestReponsive'
import BlogCatData from '../static-data/BlogCategory.json'

const breadCrumpData = [
    {
        item: "Home",
        href: '/'
    },
    {
        item: "Blog & Articles",
        href: '/blogs'
    }
]

const Blogs: React.FC = () => {
    const [activeCatTab, setActiveCatTab] = useState('all')
    return (
        <div>
            <NavBelt page='Blog' img="https://images.unsplash.com/photo-1568267329314-ef304392c9fa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" breadCrumpInfo={breadCrumpData} />
            <div className="container mx-auto px-2 lg:px-4 2xl:px-12">
                {/* <TestReponsive /> */}
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-12 justify-items-center md:justify-items-start  gap-8 mt-12 sticky top-0">
                    {/* left side of grid  */}
                    <div className="md:col-span-2 lg:col-span-8">
                        <div className="flex items-center space-x-2 cursor-pointer text-lg w-full lg:w-auto overflow-x-scroll lg:overflow-x-auto">
                            <div className={`text-gray px-2 py-1 hover:text-primary-base transition duration-300 hover:transition hover:duration-300 animate-from-right rounded-full ${activeCatTab === 'all' && 'bg-primary-base text-white animate-to-right rounded-full hover:text-white px-5'}`} onClick={() => setActiveCatTab('all')}>
                                All
                            </div>
                            {BlogCatData.map((item, i) => (
                                <p key={i} className={`text-gray px-2 py-1 hover:text-primary-base transition duration-300 hover:transition hover:duration-300 rounded-full animate-from-right w-fit ${activeCatTab === item.id && 'bg-primary-base text-white animate-to-right rounded-md hover:text-white px-5'}`} onClick={() => setActiveCatTab(item.id)}>{item.category_name}</p>
                            ))}
                        </div>
                    </div>
                    {/* right side of grid  */}
                    <div className="sm:w-3/4 md:w-full lg:col-span-4">
                        <form className="flex items-center">
                            <input type="text" name="" id="" placeholder='Search....' className='w-full rounded-md' />
                            <input type="submit" value="Search" className='bg-primary-base px-3 text-white py-2 text-lg -ml-2 rounded-tr-md rounded-br-md' />
                        </form>
                    </div>
                </div>

            </div>

            <div className="container mx-auto px-4 2xl:px-12">
                <div className="grid md:grid-cols-2 gap-10 my-24">
                    <div className="h-full w-full rounded-2xl  overflow-hidden">
                        <img src="https://images.unsplash.com/photo-1618413516603-d33a4e56c8a1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" alt="" srcSet="" className='h-full w-full object-cover' />

                    </div>
                    <div className="mt-2">
                        <p className='font-medium text-gray-500'>Trip info | 20 Aug, 2022</p>
                        <h1 className='text-3xl font-bold my-4 leading-normal'>Why your plan to visit nepal in 2022 can turned into best decision of your life</h1>
                        <p className='text-gray-800 text-justify text-lg  ine-clamp-6'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis corporis eveniet cupiditate dolores odio obcaecati officiis quo nobis adipisci, rem reiciendis consectetur placeat velit dicta quasi eum ipsa, voluptas laborum.
                            Assumenda, odio. Velit dolorem, ut a enim debitis possimus. Dolores, deleniti esse! Sunt, incidunt earum! Neque enim nisi, quidem ratione, voluptatibus laborum rerum corrupti quasi temporibus voluptatum quae adipisci perferendis.</p>
                        <div className='bg-primary-base p-4 rounded-md w-fit mt-8 text-lg text-white'>
                            <a href="" >
                                Read Blog
                            </a>
                        </div>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 gap-10 my-24">
                    <div className="h-full w-full rounded-2xl  overflow-hidden">
                        <img src="https://images.unsplash.com/photo-1622599357169-7fb71842c008?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" alt="" srcSet="" className='h-full w-full object-cover' />

                    </div>
                    <div className="mt-2">
                        <p className='font-medium text-gray-500'>Adventure | 20 Aug, 2022</p>
                        <h1 className='text-3xl font-bold my-4 leading-normal'>Wildlife visit is top grossing trip in Nepal -- Chitwan National Park</h1>
                        <p className='text-gray-800 text-justify text-lg  ine-clamp-6'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis corporis eveniet cupiditate dolores odio obcaecati officiis quo nobis adipisci, rem reiciendis consectetur placeat velit dicta quasi eum ipsa, voluptas laborum.
                            Assumenda, odio. Velit dolorem, ut a enim debitis possimus. Dolores, deleniti esse! Sunt, incidunt earum! Neque enim nisi, quidem ratione, voluptatibus laborum rerum corrupti quasi temporibus voluptatum quae adipisci perferendis.</p>
                        <div className='bg-primary-base p-4 rounded-md w-fit mt-8 text-lg text-white'>
                            <a href="" >
                                Read Blog
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Blogs